export const KEYS = {
  'site_design.change_theme_key': {
    title: 'theme_assistant_widget_featured_site_theme_title',
    text: 'theme_assistant_widget_featured_site_theme_description',
    respondText: 'theme_assistant_widget_featured_site_theme_response',
  },
  'site_design.customize_color_theme_key': {
    title: 'theme_assistant_widget_custom_colors_title',
    text: 'theme_assistant_widget_custom_colors_description',
    respondText: 'theme_assistant_widget_custom_colors_response',
  },
  'site_design.customize_color_theme.advanced_settings_key': {
    title: '_key_not_created_',
    text: '_key_not_created_',
    respondText: '_key_not_created_',
  },
  'site_design.customize_color_theme.change_color_theme_key': {
    title: 'theme_assistant_widget_featured_colors_title',
    text: 'theme_assistant_widget_featured_colors_description',
    respondText: 'theme_assistant_widget_featured_colors_response',
  },
  'site_design.customize_color_theme.color_from_logo_key': {
    title: 'theme_assistant_widget_colors_from_logo_title',
    text: 'theme_assistant_widget_colors_from_logo_description',
    respondText: 'theme_assistant_widget_colors_from_logo_response',
  },
  'site_design.customize_color_theme.color_from_text_key': {
    title: 'theme_assistant_widget_colors_from_text_title',
    text: 'theme_assistant_widget_colors_from_text_description',
    respondText: 'theme_assistant_widget_colors_from_text_response',
  },
  'site_design.customize_text_theme_key': {
    title: 'theme_assistant_widget_custom_text_title',
    text: 'theme_assistant_widget_custom_text_description',
    respondText: 'theme_assistant_widget_custom_text_response',
  },
  'site_design.customize_text_theme.customize_heading_styles_key': {
    title: 'theme_assistant_widget_edit_headings_title',
    text: 'theme_assistant_widget_edit_headings_description',
    respondText: 'theme_assistant_widget_edit_headings_response',
  },
  'site_design.customize_text_theme.customize_paragraph_styles_key': {
    title: 'theme_assistant_widget_edit_paragraphs_title',
    text: 'theme_assistant_widget_edit_paragraphs_description',
    respondText: 'theme_assistant_widget_edit_paragraphs_response',
  },
  'site_design.customize_text_theme.change_text_theme_key': {
    title: 'theme_assistant_widget_featured_text_title',
    text: 'theme_assistant_widget_featured_text_description',
    respondText: 'theme_assistant_widget_featured_text_response',
  },
} as const;
